import { z } from 'zod';
/**
 * Fayl yuklash SHARTNOMASI — ikki tomon ham shu ro'yxatdan foydalanadi.
 *
 * Ro'yxat shartnomada turishining sababi: brauzer faylni YUBORMASDAN oldin
 * turini va hajmini tekshiradi va odam 20 MB li faylni yuklab, xatoni faqat
 * kutgandan keyin ko'rmaydi. Lekin bu ro'yxat o'zi HECH NARSANI kafolatlamaydi:
 * `Content-Type` ni MIJOZ yozadi, shuning uchun serverda magic baytlar ham
 * tekshiriladi (`detectFileKind`). Ikkisi bir-birini almashtirmaydi.
 */
/** Bitta faylning eng katta hajmi — spec §4.7. */
export const MAX_FILE_UPLOAD_BYTES = 15 * 1024 * 1024;
/**
 * Fayl yo'li — bazada ham, javoblarda ham FAQAT shu ko'rinishda yuradi.
 *
 * Qoida bitta: **manzil `/` bilan TUGAYDI, kalit `/` bilan BOSHLANMAYDI.**
 * Ya'ni javobda `files/<uuid>` turadi, `http://host/api/v1/files/<uuid>` emas.
 * Sabab amaliy: to'liq manzil javobga (yoki bazaga) yozilsa, domen yoki
 * saqlash joyi o'zgargan kuni har bir eski yozuv siniq havolaga aylanardi.
 *
 * Manzilni MIJOZ yig'adi — u API ning bazaviy manzilini allaqachon biladi.
 */
export const filePathOf = (fileId) => `files/${fileId}`;
/**
 * DALOLATNOMA RASMI — talabnoma orqali.
 *
 * Nega `filePathOf` emas: `GET /files/:id` faylning O'Z doirasini
 * tekshiradi, u esa rasmni YUKLAGAN odamning ish joyidan olinadi. Qabul
 * qiluvchi boshqa korxonada bo'lsa, dalolatnoma ko'rinib turgani holda
 * rasm 404 bo'lardi — foto-hisobotning butun ma'nosi shu paytda yo'qoladi.
 *
 * Shu yo'lda ruxsat HUJJAT ustida tekshiriladi: dalolatnomani ko'ra olgan
 * odam uning rasmini ham ko'radi. Umumiy fayl ruxsati kengaymaydi.
 */
export const handoverPhotoPathOf = (requisitionId, fileId) => `requisitions/${requisitionId}/handover-photos/${fileId}`;
/**
 * Ruxsat etilgan MIME turlari (allowlist — blacklist EMAS).
 *
 * Blacklist yozilsa, unutilgan bitta tur (`image/svg+xml`, `text/html`,
 * `application/xhtml+xml`) saqlangan XSS ga aylanardi: brauzerda ochilgan SVG
 * o'z ichidagi `<script>` ni tizim domenida bajaradi.
 */
export const ALLOWED_UPLOAD_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const isAllowedUploadMime = (value) => ALLOWED_UPLOAD_MIME_TYPES.includes(value);
/**
 * Fayl NIMA UCHUN yuklanayotgani — saqlash joyi (bucket) va ko'rish qoidasi
 * shundan kelib chiqadi.
 */
export const FILE_CONTEXTS = [
    'REQUISITION_PHOTO',
    'HANDOVER_PHOTO',
    'DOC_PDF',
    'IMPORT',
    /**
     * XODIMNING IMZOSI — tizimda chizilgan rasm.
     *
     * Doirasi qolganlaridan QATTIQROQ: langar (`mtu_id`/`org_unit_id`)
     * ataylab yozilmaydi, ya'ni faylni faqat EGASI va global doiradagi xodim
     * ochadi. Bir MTU dagi hamkasb boshqaning imzosini yuklab ololmaydi.
     */
    'SIGNATURE',
    /**
     * RASXOD AKTI va uning FOTO-HISOBOTI.
     *
     * Ikki alohida kontekst, chunki ular boshqa-boshqa narsa: biri xodim
     * biriktirgan qog'oz (skan yoki PDF), ikkinchisi ishlatilgan mahsulotning
     * surati. Bitta kontekstga yig'ilsa, buxgalterga qaysi fayl akt, qaysisi
     * dalil ekani ko'rinmasdi.
     */
    'WRITE_OFF_ACT',
    'WRITE_OFF_PHOTO',
];
export const fileContextSchema = z.enum(FILE_CONTEXTS);
/**
 * Yuklash so'rovi — `multipart/form-data` ning fayldan tashqari YAGONA maydoni.
 *
 * Fayl NOMI so'rovda kelmaydi va kelsa ham ishlatilmaydi: obyekt nomi har doim
 * UUID (spec §4.7).
 */
export const uploadFileSchema = z.object({
    context: fileContextSchema,
});
/**
 * Saqlangan fayl.
 *
 * `objectKey` va `bucket` ATAYLAB yo'q: mijozga saqlash joyining ichki
 * tuzilishini bilish kerak emas va u faylga faqat imzolangan havola orqali
 * yetadi (`GET /files/:id`).
 */
export const storedFileSchema = z.object({
    id: z.string(),
    originalName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    sha256: z.string(),
    context: fileContextSchema,
    ownerUserId: z.string(),
    gps: z.object({ lat: z.number(), lng: z.number() }).nullable(),
    createdAt: z.string(),
});
/**
 * «MENING IMZOYIM» — xodim o'z imzosini o'rnatadi.
 *
 * Faqat `fileId`: xodim id si so'rovda YO'Q va bo'lmasligi ham kerak — u
 * tokendan olinadi. Aks holda bir xodim boshqasiga imzo qo'yib qo'yardi va
 * «imzo tugmani bosgan odamniki» degan qoida buzilardi.
 *
 * Fayl oldindan `POST /files` bilan `context: 'SIGNATURE'` sifatida
 * yuklanadi.
 */
export const setSignatureSchema = z.object({
    fileId: z.string().uuid(),
});
//# sourceMappingURL=file.schema.js.map